import { render, staticRenderFns } from "./DeliveryConditions.vue?vue&type=template&id=4fc7e5fc&"
import script from "./DeliveryConditions.vue?vue&type=script&lang=js&"
export * from "./DeliveryConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports